import axios from '@/utils/axios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        item: null,
        items: [],
        itemSearch: [],
        measureUnits: []
    },
    mutations: {
        setItem(state, payload) {
            state.item = payload;
        },
        setItems(state, payload) {
            state.items = payload;
        },
        setMeasureUnits(state, payload) {
            state.measureUnits = payload;
        },
        setItemsConcat(state, payload) {
            state.itemSearch = state.itemSearch.concat(payload);
        },
        resetItemMeasureUnit(state) {
            state.measureUnits = [];
        },
        pushItem(state, payload){
            state.items.push(payload);
        },
        resetItems(state) {
            state.items = [];
        }
    },
    actions: {
        storeItem({rootState, dispatch}, payload){
            return new Promise ((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/items`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        updateItem({rootState, dispatch}, payload){
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/items/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeItem({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/items/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeItems({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/items`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchItem({commit, rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/items/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItem', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchItems({commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/items?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItems', response.data.data);
                    commit('setItemsConcat', response.data.data)
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },

        // fetchItemMeasureUnits({commit, rootState, dispatch}, payload) {
        //     let query = queryString(payload);
        //     return new Promise((resolve, reject) => {
        //         axios.request({
        //             method: `get`,
        //             url: `${rootState.warehouse.routePrefix}/items/${payload.item_id}/measure-units?${query}`,
        //             headers: {Authorization: `Bearer ${rootState.authentication.token}`}
        //         })
        //         .then((response) => {
        //             commit('setMeasureUnits', response.data);
        //             resolve(response);
        //         })
        //         .catch((error) => {
        //             if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
        //             reject(error);
        //         })
        //     })
        // },
        fetchItemMeasureUnits({commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: `get`,
                    url: `${rootState.warehouse.routePrefix}/items/${payload.item_id}/available-measure-units?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    commit('setMeasureUnits', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        fetchItemMeasureUnitsConversion({commit, rootState, dispatch}, payload) {
            // let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: `get`,
                    url: `${rootState.warehouse.routePrefix}/items/${payload.item_id}/measure-units`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    commit('setMeasureUnits', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        resetItemMeasureUnit({commit}){
            commit('resetItemMeasureUnit');
        },
        pushItem({commit}, payload) {
            commit('pushItem', payload);
        },
        restItems({commit}) {
            commit('resetItems');
        },
        setItems({ commit }, payload) {
            commit('setItemsConcat', payload);
        }
    }
}